import { Typography } from 'antd'
import { TextProps } from 'antd/es/typography/Text'
import { CSSProperties, ReactNode } from 'react'

type UiTextProps = {
  children: ReactNode
  size: number
  style?: CSSProperties
  ellipsis?: boolean
} & TextProps

export const UiText = ({
  children,
  size,
  style,
  ellipsis,
  ...rest
}: UiTextProps) => {
  const { Text } = Typography
  return (
    <Text
      ellipsis={ellipsis ? { tooltip: children } : false}
      style={{ fontSize: size, ...style }}
      {...rest}
    >
      {children}
    </Text>
  )
}
